import Crud from '../views/NotificationType/Crud'
import Entity from '../views/NotificationType/Add'


let routes = {
    path: '/notification_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/notification_types/add',
            name: 'NewNotificationType',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Notificação',
                breadcrumb: [
                    {
                        text: 'Tipos de Notificação',
                        active: false,
                        to: '/notification_types',
                    },
                    {
                        text: 'Adicionar tipo de Notificação',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/notification_types/edit/:id?',
            name: 'EditNotificationType',
            component: Entity,
            meta: {
                pageTitle: 'Tipos de Notificação',
                breadcrumb: [
                    {
                        text: 'Tipos de Notificação',
                        active: false,
                        to: '/notification_types',
                    },
                    {
                        text: 'Editar tipo de Notificação',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/notification_types',
            name: 'list-notification-types',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Tipos de Notificação',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
